import script from "./personalChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./personalChat.vue?vue&type=script&setup=true&lang=ts"

import "./personalChat.vue?vue&type=style&index=0&id=f32e4b2a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f32e4b2a"]])

export default __exports__